import { render, staticRenderFns } from "./DQRCodeTemplate.vue?vue&type=template&id=6238d974&scoped=true&"
import script from "./DQRCodeTemplate.vue?vue&type=script&lang=js&"
export * from "./DQRCodeTemplate.vue?vue&type=script&lang=js&"
import style0 from "./DQRCodeTemplate.vue?vue&type=style&index=0&id=6238d974&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6238d974",
  null
  
)

export default component.exports